<template>
    <div class="position-relative">
        <img
            :src="require(`@/contents/images/${author.image}`)"
            alt="Author"
            class="img-fluid"
        >

        <span class="author-info text-white">
            {{ author.name }}

            <br>

            - {{ author.age }} jr
        </span>
    </div>
</template>

<script>
export default {
    name: 'StoryAuthor',
    props: {
        author: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.author-info {
    position: absolute;
    right: 30%;
    bottom: 15%;

    .author-sm > & {
        right: 23%;
        font-size: .7rem;
        text-shadow: 1px 1px 0 rgba(0, 0, 0, .5);
    }
}
</style>